export default "__VITE_ASSET__w9xdyT2J__"